type LeafProps = {
  className?: string;
  width?: number;
  rotate?: number;
};

/**
 * Botanical leaf accent — central stem with three side fronds.
 * Matches the decorative SVGs used on lotus-flow.de. Always `aria-hidden`.
 */
export function Leaf({ className = "", width = 90, rotate = 0 }: LeafProps) {
  return (
    <svg
      viewBox="0 0 60 120"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      style={{ width, transform: `rotate(${rotate}deg)` }}
      className={`pointer-events-none ${className}`}
    >
      <path d="M30 116 C30 80 30 40 30 6" />
      <path d="M30 92 C16 86 8 74 8 60 C24 62 30 76 30 90Z" />
      <path d="M30 70 C44 64 52 52 52 38 C36 40 30 54 30 68Z" />
      <path d="M30 48 C18 42 12 30 12 18 C26 22 30 36 30 48Z" />
    </svg>
  );
}
